import React from 'react';
import ReactDOM from 'react-dom/client';

import './main/configs/firebase';
import reportWebVitals from './main/configs/reportWebVitals';
import { ConfigProvider } from './main/ConfigProvider';

import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
